import actions from './notificationsActions'
import mutations from './notificationsMutations'

export default {
  namespaced: true,
  actions,
  mutations
}